import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';

@Component({
  selector: 'app-jknumberedit',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    JkfieldlabelComponent,
    MaterialModule,
  ],
  templateUrl: './number-edit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './number-edit.component.css'
})
export class JknumbereditComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'jknumberedit';
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() value: number | undefined = 0;
  readonly valueChange = output<number>();
  readonly min = input<number>(-99999999);//-9007199254740990;
  readonly max = input<number>(99999999); //9007199254740991;
  readonly step = input<number>(1);
  override flexStyle: any = { display: 'flex' };

  /*@Input() showSpinButtons: boolean = true;
  @Input() useLargeSpinButtons: boolean = true;
  @Input() useTouchSpinButtons: boolean = true;*/
  constructor() {
    super();
    this.width.set(100);
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  onValueChange(event: Event) {
    let newValue = 0;
    if (event.target) {
      newValue = Number((event.target as HTMLInputElement).value);
      this.value = newValue;
      if (this.valueChange) this.valueChange.emit(newValue);
    }
  }
  increment() {
    if (this.value) {
      this.value = this.value + this.step();
      this.valueChange.emit(this.value);
    };
  }

  decrement() {
    if (this.value) {
      this.value = this.value - this.step();
      this.valueChange.emit(this.value);
    };
  }

}






/*
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule,  } from '@angular/common';
import { MaterialModule } from '../../../material.module';
//import { FormsModule } from '@angular/forms';

//export type NumberBoxType = 'number' | 'text' | 'tel';

@Component({
  selector: 'app-jknumberedit',
  templateUrl: './jknumberedit.component.html',
  styleUrls: ['./jknumberedit.component.scss'],
  standalone: true,
  imports: [
    CommonModule,

    MaterialModule,
  ],
})

export class JknumbereditComponent extends JkBaseComponent implements OnInit {
  @Input()
  public enabled = true;
  @Input() autocomplete = false;
  _value: number = 0;
  @Input() get value(): number {
    return this._value;
  }
  set value(val: number) {
    this._value = val;
  }
  @Input() mode: NumberBoxType = 'number'; // fixedPoint';
  // @Input() width:string = '100px';
  @Output() valueChange = new EventEmitter<number>();
  //onValueChange(newValue: number) {
  onValueChange(event: Event) {
    //console.log('numberedit width:' + this.width);
    let newValue = 0;
    if (event.target) {
      newValue = Number((event.target as HTMLInputElement).value);
      if (this.valueChange) this.valueChange.emit(newValue);
    }
  }
  onValueChangeString(newValue: string) {
    this.valueChange.emit(Number(newValue));
  }
  @Input()
  min: number = -9007199254740990;
  @Input()
  // javascript number 的最大值 是多少
  max: number = 9007199254740991;
  @Input() hint: string = '';
  @Input() showSpinButtons: boolean = true;
  @Input() step: number = 1;
  @Input() useLargeSpinButtons: boolean = false;
  @Input() useTouchSpinButtons: boolean = false;
  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  decrement($event: MouseEvent) {
    this.value--;
    this.valueChange.emit(this.value);
  }
  increment($event: MouseEvent) {
    this.value++;
    this.valueChange.emit(this.value);
  }
}
*/
